import { c as _c } from "react/compiler-runtime";
import { Badge } from "@repo/ui/components/ui/badge";
import { Button } from "@repo/ui/components/ui/button";
import { Input } from "@repo/ui/components/ui/input";
import { Label } from "@repo/ui/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@repo/ui/components/ui/tabs";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { ArrowLeft, Check, Loader2, MapPin, Plus, Search } from "lucide-react";
import { useState } from "react";
import { PinPicker } from "@/lib/components/map/PinPicker";
import { trpc } from "@/router";

// ─── OSM Search Section ─────────────────────────────────────────────────────
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function OsmSearchTab() {
  const $ = _c(53);
  const [query, setQuery] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [results, setResults] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [importedIds, setImportedIds] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = trpc.places.searchOsm.mutationOptions({
      onSuccess: data => {
        setResults(data);
        setImportedIds(new Set());
      }
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const searchMutation = useMutation(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = trpc.places.importFromOsm.mutationOptions();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const importMutation = useMutation(t3);
  let t4;
  if ($[4] !== query || $[5] !== searchMutation) {
    t4 = function handleSearch(e) {
      e.preventDefault();
      if (query.trim().length < 2) {
        return;
      }
      searchMutation.mutate({
        query: query.trim()
      });
    };
    $[4] = query;
    $[5] = searchMutation;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleSearch = t4;
  let t5;
  if ($[7] !== importMutation) {
    t5 = async function handleImport(result) {
      await importMutation.mutateAsync({
        places: [{
          osmId: result.osmId,
          osmType: result.osmType,
          name: result.name,
          latitude: result.latitude,
          longitude: result.longitude
        }]
      });
      setImportedIds(prev => new Set([...prev, result.osmId]));
    };
    $[7] = importMutation;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleImport = t5;
  let t6;
  if ($[9] !== importMutation || $[10] !== importedIds || $[11] !== results) {
    t6 = async function handleImportAll() {
      const toImport = results.filter(r => !r.alreadyImported && !importedIds.has(r.osmId));
      if (toImport.length === 0) {
        return;
      }
      await importMutation.mutateAsync({
        places: toImport.map(_temp)
      });
      setImportedIds(prev_0 => new Set([...prev_0, ...toImport.map(_temp2)]));
    };
    $[9] = importMutation;
    $[10] = importedIds;
    $[11] = results;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleImportAll = t6;
  let t7;
  if ($[13] !== importedIds || $[14] !== results) {
    let t8;
    if ($[16] !== importedIds) {
      t8 = r_2 => !r_2.alreadyImported && !importedIds.has(r_2.osmId);
      $[16] = importedIds;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t7 = results.filter(t8);
    $[13] = importedIds;
    $[14] = results;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const importableCount = t7.length;
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = /*#__PURE__*/_jsx("p", {
      className: "text-sm text-gray-500",
      children: "S\xF6k i OpenStreetMap och importera platser"
    });
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_0 => setQuery(e_0.target.value);
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== query) {
    t10 = /*#__PURE__*/_jsx(Input, {
      value: query,
      onChange: t9,
      placeholder: "T.ex. \"Actic Hedemora\"",
      className: "flex-1"
    });
    $[20] = query;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== query || $[23] !== searchMutation.isPending) {
    t11 = searchMutation.isPending || query.trim().length < 2;
    $[22] = query;
    $[23] = searchMutation.isPending;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== searchMutation.isPending) {
    t12 = searchMutation.isPending ? /*#__PURE__*/_jsx(Loader2, {
      className: "size-4 animate-spin"
    }) : /*#__PURE__*/_jsx(Search, {
      className: "size-4"
    });
    $[25] = searchMutation.isPending;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = /*#__PURE__*/_jsxs(Button, {
      type: "submit",
      disabled: t11,
      children: [t12, "S\xF6k"]
    });
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== handleSearch || $[31] !== t10 || $[32] !== t13) {
    t14 = /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSearch,
      className: "flex gap-2",
      children: [t10, t13]
    });
    $[30] = handleSearch;
    $[31] = t10;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== searchMutation.error || $[35] !== searchMutation.isError) {
    t15 = searchMutation.isError && /*#__PURE__*/_jsxs("p", {
      className: "text-sm text-red-500",
      children: ["S\xF6kning misslyckades: ", searchMutation.error.message]
    });
    $[34] = searchMutation.error;
    $[35] = searchMutation.isError;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== handleImport || $[38] !== handleImportAll || $[39] !== importMutation || $[40] !== importableCount || $[41] !== importedIds || $[42] !== results) {
    t16 = results.length > 0 && /*#__PURE__*/_jsxs("div", {
      className: "space-y-3",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between",
        children: [/*#__PURE__*/_jsxs("p", {
          className: "text-sm text-gray-500",
          children: [results.length, " resultat"]
        }), importableCount > 1 && /*#__PURE__*/_jsxs(Button, {
          variant: "outline",
          size: "sm",
          onClick: handleImportAll,
          disabled: importMutation.isPending,
          children: ["Importera alla (", importableCount, ")"]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "divide-y rounded-md border",
        children: results.map(result_0 => {
          const isImported = result_0.alreadyImported || importedIds.has(result_0.osmId);
          return /*#__PURE__*/_jsxs("div", {
            className: "flex items-center justify-between gap-3 px-3 py-3",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "min-w-0 flex-1",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex items-center gap-2",
                children: [/*#__PURE__*/_jsx("span", {
                  className: "font-medium",
                  children: result_0.name
                }), /*#__PURE__*/_jsx(Badge, {
                  variant: "secondary",
                  className: "text-xs",
                  children: result_0.category
                })]
              }), /*#__PURE__*/_jsx("p", {
                className: "text-xs text-gray-400",
                children: result_0.displayName
              }), /*#__PURE__*/_jsxs("div", {
                className: "flex items-center gap-1 text-xs text-gray-400",
                children: [/*#__PURE__*/_jsx(MapPin, {
                  className: "size-3"
                }), result_0.latitude.toFixed(4), ", ", result_0.longitude.toFixed(4)]
              })]
            }), isImported ? /*#__PURE__*/_jsxs(Badge, {
              variant: "outline",
              className: "gap-1 text-gray-400",
              children: [/*#__PURE__*/_jsx(Check, {
                className: "size-3"
              }), "Importerad"]
            }) : /*#__PURE__*/_jsx(Button, {
              size: "sm",
              variant: "outline",
              onClick: () => handleImport(result_0),
              disabled: importMutation.isPending,
              children: "Importera"
            })]
          }, result_0.osmId);
        })
      })]
    });
    $[37] = handleImport;
    $[38] = handleImportAll;
    $[39] = importMutation;
    $[40] = importableCount;
    $[41] = importedIds;
    $[42] = results;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== query || $[45] !== results.length || $[46] !== searchMutation.isSuccess) {
    t17 = searchMutation.isSuccess && results.length === 0 && /*#__PURE__*/_jsxs("p", {
      className: "mt-4 text-center text-sm text-gray-500",
      children: ["Inga resultat hittades f\xF6r \"", query, "\""]
    });
    $[44] = query;
    $[45] = results.length;
    $[46] = searchMutation.isSuccess;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t14 || $[49] !== t15 || $[50] !== t16 || $[51] !== t17) {
    t18 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-4",
      children: [t8, t14, t15, t16, t17]
    });
    $[48] = t14;
    $[49] = t15;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  return t18;
}

// ─── Manual Create Tab ──────────────────────────────────────────────────────
function _temp2(r_1) {
  return r_1.osmId;
}
function _temp(r_0) {
  return {
    osmId: r_0.osmId,
    osmType: r_0.osmType,
    name: r_0.name,
    latitude: r_0.latitude,
    longitude: r_0.longitude
  };
}
function ManualCreateTab() {
  const $ = _c(102);
  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [description, setDescription] = useState("");
  const [created, setCreated] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = trpc.experiences.categories.all.queryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: allCategories
  } = useQuery(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = trpc.places.create.mutationOptions({
      onSuccess: () => {
        setCreated(true);
        setName("");
        setCategoryId("");
        setLatitude("");
        setLongitude("");
        setDescription("");
        setTimeout(() => setCreated(false), 3000);
      }
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const createMutation = useMutation(t1);
  let t10;
  let t11;
  let t12;
  let t13;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== allCategories || $[3] !== categoryId || $[4] !== createMutation || $[5] !== description || $[6] !== latitude || $[7] !== longitude || $[8] !== name) {
    const parents = (allCategories ?? []).filter(_temp3);
    const children = (allCategories ?? []).filter(_temp4);
    let t14;
    if ($[21] !== categoryId || $[22] !== createMutation || $[23] !== description || $[24] !== latitude || $[25] !== longitude || $[26] !== name) {
      t14 = function handleSubmit(e) {
        e.preventDefault();
        if (!name.trim() || !categoryId || !latitude || !longitude) {
          return;
        }
        createMutation.mutate({
          name: name.trim(),
          categoryId: Number(categoryId),
          latitude: parseFloat(latitude),
          longitude: parseFloat(longitude),
          description: description.trim() || undefined
        });
      };
      $[21] = categoryId;
      $[22] = createMutation;
      $[23] = description;
      $[24] = latitude;
      $[25] = longitude;
      $[26] = name;
      $[27] = t14;
    } else {
      t14 = $[27];
    }
    const handleSubmit = t14;
    t12 = "space-y-4";
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = /*#__PURE__*/_jsx("p", {
        className: "text-sm text-gray-500",
        children: "L\xE4gg till en plats som inte finns i OpenStreetMap"
      });
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    t9 = handleSubmit;
    t10 = "space-y-4";
    let t15;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = /*#__PURE__*/_jsx(Label, {
        htmlFor: "place-name",
        children: "Namn *"
      });
      $[29] = t15;
    } else {
      t15 = $[29];
    }
    let t16;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = e_0 => setName(e_0.target.value);
      $[30] = t16;
    } else {
      t16 = $[30];
    }
    if ($[31] !== name) {
      t11 = /*#__PURE__*/_jsxs("div", {
        children: [t15, /*#__PURE__*/_jsx(Input, {
          id: "place-name",
          value: name,
          onChange: t16,
          placeholder: "T.ex. Actic Hedemora"
        })]
      });
      $[31] = name;
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = /*#__PURE__*/_jsx(Label, {
        htmlFor: "place-category",
        children: "Kategori *"
      });
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    t2 = "place-category";
    t3 = categoryId;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = e_1 => setCategoryId(e_1.target.value ? Number(e_1.target.value) : "");
      $[34] = t4;
    } else {
      t4 = $[34];
    }
    t5 = "border-input bg-background w-full rounded-md border px-3 py-2 text-sm";
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = /*#__PURE__*/_jsx("option", {
        value: "",
        children: "V\xE4lj kategori..."
      });
      $[35] = t6;
    } else {
      t6 = $[35];
    }
    t7 = parents.map(parent => /*#__PURE__*/_jsx("optgroup", {
      label: parent.name,
      children: children.filter(c_1 => c_1.parentId === parent.id).map(_temp5)
    }, parent.id));
    $[2] = allCategories;
    $[3] = categoryId;
    $[4] = createMutation;
    $[5] = description;
    $[6] = latitude;
    $[7] = longitude;
    $[8] = name;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t13;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t13 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t14;
  if ($[36] !== t2 || $[37] !== t3 || $[38] !== t4 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7) {
    t14 = /*#__PURE__*/_jsxs("select", {
      id: t2,
      value: t3,
      onChange: t4,
      className: t5,
      children: [t6, t7]
    });
    $[36] = t2;
    $[37] = t3;
    $[38] = t4;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t14 || $[44] !== t8) {
    t15 = /*#__PURE__*/_jsxs("div", {
      children: [t8, t14]
    });
    $[43] = t14;
    $[44] = t8;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  let t17;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = /*#__PURE__*/_jsx(Label, {
      children: "Plats p\xE5 kartan *"
    });
    t17 = /*#__PURE__*/_jsx("p", {
      className: "mb-2 text-xs text-gray-500",
      children: "Klicka p\xE5 kartan f\xF6r att placera en mark\xF6r. Dra mark\xF6ren f\xF6r att justera."
    });
    $[46] = t16;
    $[47] = t17;
  } else {
    t16 = $[46];
    t17 = $[47];
  }
  const t18 = latitude ? parseFloat(latitude) : undefined;
  const t19 = longitude ? parseFloat(longitude) : undefined;
  let t20;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = (lat, lng) => {
      setLatitude(lat.toFixed(6));
      setLongitude(lng.toFixed(6));
    };
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t18 || $[50] !== t19) {
    t21 = /*#__PURE__*/_jsx(PinPicker, {
      latitude: t18,
      longitude: t19,
      onPick: t20
    });
    $[49] = t18;
    $[50] = t19;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = /*#__PURE__*/_jsx(Label, {
      htmlFor: "place-lat",
      children: "Latitud"
    });
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = e_2 => setLatitude(e_2.target.value);
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== latitude) {
    t24 = /*#__PURE__*/_jsxs("div", {
      children: [t22, /*#__PURE__*/_jsx(Input, {
        id: "place-lat",
        type: "number",
        step: "any",
        value: latitude,
        onChange: t23,
        placeholder: "60.2750"
      })]
    });
    $[54] = latitude;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = /*#__PURE__*/_jsx(Label, {
      htmlFor: "place-lng",
      children: "Longitud"
    });
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = e_3 => setLongitude(e_3.target.value);
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== longitude) {
    t27 = /*#__PURE__*/_jsxs("div", {
      children: [t25, /*#__PURE__*/_jsx(Input, {
        id: "place-lng",
        type: "number",
        step: "any",
        value: longitude,
        onChange: t26,
        placeholder: "16.0042"
      })]
    });
    $[58] = longitude;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t24 || $[61] !== t27) {
    t28 = /*#__PURE__*/_jsxs("div", {
      className: "mt-2 grid grid-cols-2 gap-3",
      children: [t24, t27]
    });
    $[60] = t24;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== t21 || $[64] !== t28) {
    t29 = /*#__PURE__*/_jsxs("div", {
      children: [t16, t17, t21, t28]
    });
    $[63] = t21;
    $[64] = t28;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = /*#__PURE__*/_jsx(Label, {
      htmlFor: "place-desc",
      children: "Beskrivning"
    });
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = e_4 => setDescription(e_4.target.value);
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== description) {
    t32 = /*#__PURE__*/_jsxs("div", {
      children: [t30, /*#__PURE__*/_jsx(Input, {
        id: "place-desc",
        value: description,
        onChange: t31,
        placeholder: "Valfri beskrivning"
      })]
    });
    $[68] = description;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== categoryId || $[71] !== createMutation.isPending || $[72] !== latitude || $[73] !== longitude || $[74] !== name) {
    t33 = createMutation.isPending || !name.trim() || !categoryId || !latitude || !longitude;
    $[70] = categoryId;
    $[71] = createMutation.isPending;
    $[72] = latitude;
    $[73] = longitude;
    $[74] = name;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== createMutation.isPending) {
    t34 = createMutation.isPending ? /*#__PURE__*/_jsx(Loader2, {
      className: "size-4 animate-spin"
    }) : /*#__PURE__*/_jsx(Plus, {
      className: "size-4"
    });
    $[76] = createMutation.isPending;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== t33 || $[79] !== t34) {
    t35 = /*#__PURE__*/_jsxs(Button, {
      type: "submit",
      disabled: t33,
      children: [t34, "Skapa plats"]
    });
    $[78] = t33;
    $[79] = t34;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  let t36;
  if ($[81] !== created) {
    t36 = created && /*#__PURE__*/_jsxs("span", {
      className: "flex items-center gap-1 text-sm text-green-600",
      children: [/*#__PURE__*/_jsx(Check, {
        className: "size-4"
      }), "Platsen skapades!"]
    });
    $[81] = created;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  let t37;
  if ($[83] !== t35 || $[84] !== t36) {
    t37 = /*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-3",
      children: [t35, t36]
    });
    $[83] = t35;
    $[84] = t36;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] !== createMutation.error || $[87] !== createMutation.isError) {
    t38 = createMutation.isError && /*#__PURE__*/_jsxs("p", {
      className: "text-sm text-red-500",
      children: ["Kunde inte skapa plats: ", createMutation.error.message]
    });
    $[86] = createMutation.error;
    $[87] = createMutation.isError;
    $[88] = t38;
  } else {
    t38 = $[88];
  }
  let t39;
  if ($[89] !== t10 || $[90] !== t11 || $[91] !== t15 || $[92] !== t29 || $[93] !== t32 || $[94] !== t37 || $[95] !== t38 || $[96] !== t9) {
    t39 = /*#__PURE__*/_jsxs("form", {
      onSubmit: t9,
      className: t10,
      children: [t11, t15, t29, t32, t37, t38]
    });
    $[89] = t10;
    $[90] = t11;
    $[91] = t15;
    $[92] = t29;
    $[93] = t32;
    $[94] = t37;
    $[95] = t38;
    $[96] = t9;
    $[97] = t39;
  } else {
    t39 = $[97];
  }
  let t40;
  if ($[98] !== t12 || $[99] !== t13 || $[100] !== t39) {
    t40 = /*#__PURE__*/_jsxs("div", {
      className: t12,
      children: [t13, t39]
    });
    $[98] = t12;
    $[99] = t13;
    $[100] = t39;
    $[101] = t40;
  } else {
    t40 = $[101];
  }
  return t40;
}

// ─── Main View ──────────────────────────────────────────────────────────────
function _temp5(child) {
  return /*#__PURE__*/_jsx("option", {
    value: child.id,
    children: child.name
  }, child.id);
}
function _temp4(c_0) {
  return c_0.parentId !== null;
}
function _temp3(c) {
  return c.parentId === null;
}
export function AddPlaceView() {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsxs(Link, {
      to: "/admin",
      className: "mb-6 inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-900",
      children: [/*#__PURE__*/_jsx(ArrowLeft, {
        className: "size-4"
      }), "Tillbaka"]
    });
    t1 = /*#__PURE__*/_jsx("h1", {
      className: "mb-6 text-2xl font-bold",
      children: "L\xE4gg till plats"
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsxs(TabsList, {
      children: [/*#__PURE__*/_jsx(TabsTrigger, {
        value: "osm",
        children: "Fr\xE5n OpenStreetMap"
      }), /*#__PURE__*/_jsx(TabsTrigger, {
        value: "manual",
        children: "Skapa manuellt"
      })]
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(TabsContent, {
      value: "osm",
      className: "pt-4",
      children: /*#__PURE__*/_jsx(OsmSearchTab, {})
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = /*#__PURE__*/_jsxs("div", {
      className: "mx-auto max-w-2xl px-4 py-8",
      children: [t0, t1, /*#__PURE__*/_jsxs(Tabs, {
        defaultValue: "osm",
        children: [t2, t3, /*#__PURE__*/_jsx(TabsContent, {
          value: "manual",
          className: "pt-4",
          children: /*#__PURE__*/_jsx(ManualCreateTab, {})
        })]
      })]
    });
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}